module.exports = __webpack_public_path__ + "static/img/el-tenedor-rosa-1.401902d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/el-tenedor-rosa-1.jpg
// module id = PtVB
// module chunks = 1